// extracted by mini-css-extract-plugin
export default {"addModalContainer":"AddAdmin_addModalContainer__T0rFA","addElementCont":"AddAdmin_addElementCont__ivTvv","submitButton":"AddAdmin_submitButton__yxBck"};